import React, { useCallback } from 'react'

import { useTranslation } from 'react-i18next'
import { GetProps, Input } from 'antd'
import { useSelector } from 'react-redux'
import { useAction } from '@agro-club/frontend-shared'
import CompanySelectors from '../../../../../modules/domain/company/selectors'
import CompanyActions from '../../../../../modules/domain/company/duck'

const { Search } = Input
type SearchProps = GetProps<typeof Input.Search>

type AssetCompanySearchInputFilterProps = SearchProps & {
  companyIds: string[]
}

const AssetCompanySearchInputFilter: React.FC<AssetCompanySearchInputFilterProps> = ({ companyIds, ...restProps }) => {
  const { t } = useTranslation('company')
  const assetCompanyFilter = useSelector(CompanySelectors.listByIdsFilter)
  const assetCompanyFilterUpdate = useAction(CompanyActions.listByIdsFilterUpdated)
  const handleSearchChange = useCallback(
    (search?: string) => {
      assetCompanyFilterUpdate({ filters: { ...assetCompanyFilter, search }, company_ids: companyIds })
    },
    [assetCompanyFilter, assetCompanyFilterUpdate, companyIds],
  )

  const onSearch: SearchProps['onSearch'] = (value, _e, _info) => {
    handleSearchChange(value)
  }

  return <Search {...restProps} placeholder={t('component.input.placeholder')} onSearch={onSearch} />
}

export default AssetCompanySearchInputFilter
